// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Singapore */
const SG = /^(?:80[1-9]\d{5}|(?:8[1-9]|9[0-8])\d{6})$/;

export default SG;
